import { queryClient } from "../queryClient";
import { useSessionStore } from "../SessionStore";

const shouldClearStorageKey = (key: string) => {
  return (
    key === "tempStatusMap" ||
    key.startsWith("tempStatusTime_") ||
    key.startsWith("tempStatusExpire_")
  );
};

const clearUserScopedStorage = () => {
  if (typeof window === "undefined") return;
  const keys = Object.keys(localStorage);
  keys.forEach((key) => {
    if (shouldClearStorageKey(key)) {
      localStorage.removeItem(key);
    }
  });
};

export const resetAllUserScopedState = () => {
  useSessionStore.getState().reset();
  clearUserScopedStorage();
  queryClient.removeQueries({ queryKey: ["usage-status"], exact: true });
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent("user-scoped-reset"));
  }
};
